// extracted by mini-css-extract-plugin
module.exports = {"root":"ModalInventoryLogs_root__vQI-8","log":"ModalInventoryLogs_log__2zgtt","date":"ModalInventoryLogs_date__1HFIC","userName":"ModalInventoryLogs_userName__2jp_e"};